import { Thunk } from 'ha/myredux/types';
import { reportError } from 'ha/helpers/bugsnag/reportError';
import { Actions } from '../constants';

const loadCity =
  ({
    countryCode,
    city,
    lang,
  }: {
    countryCode: string;
    city: string;
    lang: string;
  }): Thunk =>
  (dispatch, _, services) => {
    dispatch({
      type: Actions.LOAD_CITY_START,
      payload: { countryCode, city, lang },
      error: false,
    });

    return services.apiV2
      .searchCity({ query: `${city}, ${countryCode}`, languages: [lang] })
      .then(({ data }) => data[lang])
      .then(cityLocalised => {
        dispatch({
          type: Actions.LOAD_CITY_DONE,
          payload: cityLocalised,
          error: false,
        });

        return cityLocalised;
      })
      .catch(errors => {
        reportError('Load City', { metaData: { errors } });
      });
  };

export { loadCity };
